<style>
  body {
    font-family: 'Quicksand', 'Open Sans', sans-serif;
  }
</style>
<div class="wrapper">
  <div class="row text-center" style="align-items: center;justify-content: center;height: 100%;">
    <div class="col-md-offset-3 col-md-6 text-center">
      <div class="page-bar" style="padding: 50px; margin:50px;">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="" height="30mm"
          viewBox="0 0 360 401.08">
          <defs>
            <style>
              .cls-1 {
                fill: #cfd8dc;
              }

              .cls-2,
              .cls-7 {
                fill: #a6e7ff;
              }

              .cls-3 {
                fill: #90a4ae;
              }

              .cls-4 {
                fill: #ff8a65;
              }

              .cls-5 {
                fill: #ffe082;
              }

              .cls-6 {
                fill: #fff;
              }

              .cls-7 {
                stroke: #000;
                stroke-miterlimit: 10;
                stroke-width: 8px;
              }

              .cls-8 {
                font-size: 87.57px;
                font-family: OCRAExtended, OCR A Extended;
              }
            </style>
          </defs>
          <title>access-control</title>
          <path class="cls-1" d="M141.88,107.62H378.13V411.38H141.88Z" transform="translate(-80 -60.92)" />
          <path class="cls-2" d="M164.38,130.12H355.63V411.38H164.38Z" transform="translate(-80 -60.92)" />
          <path class="cls-3" d="M80,411.38H440v22.5H80Z" transform="translate(-80 -60.92)" />
          <path class="cls-4" d="M209.38,242.63H310.63v78.75H209.38Z" transform="translate(-80 -60.92)" />
          <path class="cls-5"
            d="M175.63,231.38a11.25,11.25,0,0,1,11.25,11.25v22.5a11.25,11.25,0,0,1-22.5,0v-22.5A11.24,11.24,0,0,1,175.63,231.38Z"
            transform="translate(-80 -60.92)" />
          <path class="cls-5"
            d="M254.38,456.38A27.34,27.34,0,0,1,230,441.28l-24.19-48.43a15.66,15.66,0,0,1,27.4-15.12l13.54,22.4h2.05V301.69a14.07,14.07,0,0,1,28.13,0V349.5h16.87A11.25,11.25,0,0,1,305,360.75h16.88A11.25,11.25,0,0,1,333.13,372h11.25a11.25,11.25,0,0,1,11.25,11.25v50.63l-16.88,22.5Z"
            transform="translate(-80 -60.92)" />
          <path class="cls-6"
            d="M235.14,280.5l-7.64-8.25a47.8,47.8,0,0,1,65,0l-7.64,8.25A36.58,36.58,0,0,0,235.14,280.5Z"
            transform="translate(-80 -60.92)" />
          <path
            d="M361.25,417H417.5V405.75H383.75V102H136.25V405.75H102.5V417h109l5.63,11.25H80V439.5H222.77l2.15,4.3A32.77,32.77,0,0,0,254.38,462h87.18l16.88-22.5H440V428.25H361.25ZM350,428.25V432l-14.06,18.75H254.38a21.56,21.56,0,0,1-19.39-12l-24.23-48.44a10,10,0,0,1,17.56-9.69l15.21,25.11h10.85V301.69a8.44,8.44,0,1,1,16.87,0V372H282.5V355.13h11.25a5.62,5.62,0,0,1,5.63,5.62v22.5h11.25V366.38h11.25A5.62,5.62,0,0,1,327.5,372v22.5h11.25V377.63h5.63a5.62,5.62,0,0,1,5.62,5.62Zm-45-180v67.5H282.5V301.69a19.69,19.69,0,1,0-39.37,0v14.06H215v-67.5ZM226.25,237V214.5a33.75,33.75,0,0,1,67.5,0V237ZM344.38,366.38h-6.59a16.9,16.9,0,0,0-15.91-11.25H309.66a16.89,16.89,0,0,0-15.91-11.25H282.5V327h33.75V237H305V214.5a45,45,0,0,0-90,0V237H203.75v90h39.38v56.37l-5.19-8.56a21.29,21.29,0,0,0-37.24,20.55l5.2,10.39H170V293.25H158.75v112.5H147.5V113.25h225v292.5H361.25v-22.5A16.87,16.87,0,0,0,344.38,366.38Z"
            transform="translate(-80 -60.92)" />
          <path
            d="M175.63,225.75a16.88,16.88,0,0,0-16.88,16.88v22.5a16.88,16.88,0,0,0,33.75,0v-22.5A16.88,16.88,0,0,0,175.63,225.75Zm5.62,39.38a5.63,5.63,0,0,1-11.25,0v-22.5a5.63,5.63,0,1,1,11.25,0Z"
            transform="translate(-80 -60.92)" />
          <path d="M361.25,124.5H158.75v90H170V135.75H350V355.13h11.25Z" transform="translate(-80 -60.92)" />
          <path d="M80,405.75H91.25V417H80Z" transform="translate(-80 -60.92)" />
          <path d="M428.75,405.75H440V417H428.75Z" transform="translate(-80 -60.92)" />
          <circle class="cls-7" cx="182.5" cy="52.33" r="42.5" />
          <text class="cls-8" transform="translate(155.45 72.2)">x</text>
        </svg>
        <h1 style="font-weight: bold;">401</h1>
        <h3 style="font-weight: bold;"> Oops! UNAUTHORIZED ACCESS !</h3>
      </div>
    </div>
  </div>
</div>
